var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"row",attrs:{"name":"groups-list","tag":"div"}},_vm._l((_vm.groups),function(group){return _c('group-card',{key:group.id,staticClass:"groups-list-item",attrs:{"group":group}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }